import asyncThunk from '@/lib/asyncThunk'
import { SSO } from '@/out/single-sign-on'

type Request = Record<never, never>

export const retrieveSSO = asyncThunk<Request, SSO>({
  name: 'sso/retrieve',
  uri: '/sso',
})
